'use client';

import { useEffect } from 'react';
import {
  parseAdcashClickId,
  saveAdcashClickId,
} from '@/lib/utils/adcashTracking';

export default function SetAdcashTracking() {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const searchParams = new URLSearchParams(window.location.search);
    const clickData = parseAdcashClickId(searchParams);

    if (clickData) {
      saveAdcashClickId(clickData);
    }
  }, []);

  return null;
}
